// extracted by mini-css-extract-plugin
module.exports = {"root":"CreateCustomTemplateModal_root__2wK_X"};